/**
 * Copy each named field from `source` onto `target` when the source value is
 * neither `null` nor `undefined`. Skipping nullish preserves caller-provided
 * defaults on the target — the import parser surfaces missing GraphQL fields
 * as `null`, and overwriting valid defaults with `null` breaks downstream
 * strict schema parses.
 *
 * The `K extends keyof T` constraint means the key list cannot drift away
 * from the target shape: renaming or removing a target field surfaces as a
 * compile error at every call site that listed the stale key.
 */
export function assignDefined<T extends object, K extends keyof T>(
  target: T,
  source: { [P in K]?: T[P] | null | undefined } | null | undefined,
  keys: readonly K[],
): void {
  if (!source) return
  for (const key of keys) {
    const value = source[key]
    if (value != null) target[key] = value
  }
}
